import { render, staticRenderFns } from "./mediaLibrary.vue?vue&type=template&id=06c6cc70"
import script from "./mediaLibrary.vue?vue&type=script&lang=js"
export * from "./mediaLibrary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports